import React from 'react';
import { Box, ContentContainer, Stack } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Layout from './Layout';
import { metaOverrideSet } from '../metaOverride';

const Content = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <Box>
      <ContentContainer maxWidth={'md'}>
        <Stack direction={'column'} alignItems={'center'} spacing={3}>
          <MetaResourceRenderer
            resource={resource}
            layout={Layout}
            metaOverrideSet={metaOverrideSet}
          />
        </Stack>
      </ContentContainer>
    </Box>
  );
};

Content.defaultProps = {
};

Content.propTypes = {
};

export default Content;
